import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function EmotionalCost() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 lg:py-28 bg-brand-cream border-t border-black/5" data-id="element-39">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-black mb-6 text-balance" data-id="element-42">
            {t('cost.title')}
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="prose prose-lg prose-p:text-brand-text/80 prose-p:leading-relaxed mx-auto" data-id="element-43">
          <p className="text-xl font-medium text-brand-black text-center mb-8" data-id="element-44">
            {t('cost.p1')}
          </p>

          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-black/5 space-y-6" data-id="element-45">
            <p data-id="element-46">{t('cost.p2')}</p>

            <p data-id="element-47">{t('cost.p3')}</p>

            <div className="pt-6 border-t border-brand-gold/20 text-center" data-id="element-48">
              <p className="text-2xl font-serif font-bold text-brand-goldDark m-0" data-id="element-49">
                {t('cost.p4')}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}